<template>
  <el-upload
    class="drag-uploader"
    drag
    multiple
    :action="`/action/upload?type=${type}`"
    :on-remove="handleRemove"
    :on-error="handleError"
    :on-success="handleSuccess"
    :before-upload="handleBeforeUpload"
    :on-preview="handlePreview"
    :disabled="uploading"
    :file-list="fileList"
  >
    <i class="el-icon-upload" />
    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    <!-- <div slot="tip" class="el-upload__tip">支持上传 {{ acceptType.join('/') }} 文件</div> -->
  </el-upload>
</template>

<script>
import { licenseFileType, STATUS_CODE } from '@/utils/constants'
import { validateFileExt } from '@/utils/validate'
import { downloadFile } from '@/utils/fileUtil'

const typeMap = {
  license: licenseFileType
}

export default {
  name: 'MaterialUpload',
  props: {
    fileList: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'license'
    }
  },
  data() {
    return {
      uploadFileList: [],
      uploading: false,
      uploadCount: 0
    }
  },
  computed: {
    acceptType() {
      return typeMap[this.type]
    }
  },
  methods: {
    emitChange(files) {
      this.$emit('update:fileList', files)
    },
    deleteFile(file, fileList) {
      if (!file || !fileList) return
      const idx = fileList.findIndex(item => item.uid === file.uid)
      if (idx !== -1) {
        fileList.splice(idx, 1)
      }
    },
    handleBeforeUpload(file) {
      if (!validateFileExt(this.acceptType, file.name)) {
        // FIX 解决同时上传多个文件不符合格式要求时 $message 提示重叠的问题
        this.$autoCloseMsg(2000, {
          type: 'warning',
          message: `【${file.name}】文件上传失败，该格式暂不支持上传`
        }, false)
        return Promise.reject()
      }

      this.uploadCount++
      this.uploading = true
      return Promise.resolve()
    },
    handlePreview(file) {
      downloadFile(file.url, file.name)
    },
    handleError(error) {
      this.uploadCount--
      this.$message.error(`上传异常(${error?.message})`, '提示')
    },
    handleRemove(file, fileList) {
      // FIX 多个文件同时上传时，如果拖拽文件不符合文件格式要求，会触发 remove 回调，导致文件列表展示异常
      if (this.fileList.find(item => item.uid === file.uid)) {
        this.emitChange(fileList.filter(v => v.status === 'success'))
      }
    },
    handleSuccess(resp, file, fileList) {
      const respData = resp.data
      this.uploadCount--

      if (resp.code === STATUS_CODE.SUCCESS) {
        // 根据 md5 判断文件是否在已有文件列表重复
        if (this.fileList.find(item => item.md5 === respData.md5)) {
          this.deleteFile(file, fileList)
          this.$message.warning(`【${file.name}】文件已存在`, '提示')
        } else if (this.uploadFileList.find(item => item.md5 === respData.md5)) {
          this.deleteFile(file, fileList)
          this.$message.warning(`【${file.name}】重复上传`, '提示')
        } else {
          this.uploadFileList.push({
            fileUrl: respData.url,
            filePath: respData.file_id,
            fileSize: file.size,
            fileName: file.name,
            name: file.name,
            url: this.$toPreview(respData.url),
            md5: respData.md5
          })
        }

        if (this.uploadCount === 0) {
          this.emitChange([...this.fileList, ...this.uploadFileList])
          this.uploadFileList = []
          this.uploading = false
        }
      }
    }
  }
}
</script>

<style>
  .drag-uploader .el-upload {
    display: block;
  }

  .drag-uploader .el-upload-dragger {
    width: 100%;
    height: auto;
    padding: 6px 0;
  }

  .drag-uploader .el-icon-upload {
    margin: 0;
    font-size: 32px;
    line-height: 1em;
  }
</style>
